import React, { useEffect } from "react";
import { QuestionTypes } from "../../../../../static/enums/Questions";
import { useFormContext } from "react-hook-form";
import { InputTextAnswer } from "../../../../common/InputTextAnswer";
import { ChoiceTextSingle } from "../../../../common/ChoiceTextSingle";
import ChoiceTextMultiple from "../../../../common/ChoiceTextMultiple/ChoiceTextMultiple";
import InputTableAnswer from "../../../../common/InputTableAnswer/InputTableAnswer";
import UnionSystemAnswer from "../../../../common/UnionSystemAnswer/UnionSystemAnswer";

interface QuestionAnswerProps {
	prefix?: string;
}

export default function QuestionAnswer({ prefix = "" }: QuestionAnswerProps) {
	const { getValues, watch } = useFormContext();
	watch(`${prefix}class`);

	switch (getValues(`${prefix}class`)) {
		case QuestionTypes.choice_text_multiple:
			return <ChoiceTextMultiple prefix={prefix} />;
		case QuestionTypes.choice_text_single:
			return <ChoiceTextSingle prefix={prefix} />;
		case QuestionTypes.input_table:
			return <InputTableAnswer prefix={prefix} />;
		case QuestionTypes.input_text:
			return (
				<InputTextAnswer prefix={prefix} editorTitle={"Ответ"} displayTitle={"Отображение ответа"} height={"100px"} />
			);
		case QuestionTypes.input_unions_systems:
			return <UnionSystemAnswer prefix={prefix} />;
		case QuestionTypes.upload_handwriting:
		case QuestionTypes.dummy:
		case QuestionTypes.choice_picture_multiple:
		case QuestionTypes.choice_picture_single:
			return <RenderEmptyAnswer type={getValues(`${prefix}class`)} prefix={prefix} />;
	}

	return null;
}

function RenderEmptyAnswer({ type, prefix = "" }: { type: QuestionTypes; prefix?: string }) {
	const { setValue, formState, resetField } = useFormContext();

	useEffect(() => {
		if (formState.dirtyFields[`${prefix}class`]) {
			setValue(`${prefix}correct_answer`, null);
			setValue(`${prefix}answer_config`, null);
			resetField(`${prefix}class`, {
				keepDirty: true,
				defaultValue: type,
			});
		}
	}, []);

	return null;
}
